import React from 'react';
import { Divider, LineAboveDivider } from '@moda/om';
import { useFeatureFlag } from '@moda/portal-stanchions';
import classNames from 'classnames';
import { HomePageHeaderListItemFragment } from '../../generated/types';
import { HomePageHeaderListItem } from './HomePageHeaderListItem';
import './HomePageHeaderList.scss';

export interface Props {
  list: HomePageHeaderListItemFragment[];
  headerText?: string;
  className: string;
}

export const HomePageHeaderList: React.FC<Props> = ({ list, headerText, className }) => {
  const useNewDividerLine = useFeatureFlag('new-divider-line', [
    { default: false },
    { if: true, then: true }
  ]);

  return (
    <div className={classNames('HomePageHeaderList', className)}>
      {Boolean(headerText) && (
        <h2 className="HomePageHeaderList__header">
          {!useNewDividerLine && <Divider text={headerText} />}
          {useNewDividerLine && <LineAboveDivider text={headerText} />}
        </h2>
      )}

      {list.map(listItem => (
        <HomePageHeaderListItem key={listItem.ctaUrl} listItem={listItem} />
      ))}
    </div>
  );
};
